import { render, staticRenderFns } from "./editBrands.vue?vue&type=template&id=57b98935&"
import script from "./editBrands.vue?vue&type=script&lang=js&"
export * from "./editBrands.vue?vue&type=script&lang=js&"
import style0 from "./editBrands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports